import {
  ButtonColor,
  PrimaryButton,
} from 'component-library/components/buttons/PrimaryButton';
import { Flex } from 'component-library/components/layout/Flex';
import { LinkWrapper } from 'component-library/components/links/LinkWrapper';
import { Body } from 'component-library/components/typography/Body';
import { Heading } from 'component-library/components/typography/Heading';
import { colors } from 'component-library/styles/colors';
import React, { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled(Flex)`
  background: ${colors.teal};
  padding: 32px;
  border-radius: 24px;
`;

interface CallToActionProps {
  title?: string;
  subCopy?: string;
  buttonText?: string;
  linkPath?: string;
}

export const CallToAction: FC<CallToActionProps> = ({
  title = 'Schedule your FREE retirement consultation',
  subCopy = "You're ready for retirement. Make sure your money is too.",
  buttonText = 'Get started →',
  linkPath = '/welcome',
}) => (
  <Wrapper marginTop={32} column>
    <Heading marginBottom={12} variant={4}>
      {title}
    </Heading>
    <Body variant={2} as="span" marginBottom={24}>
      {subCopy}
    </Body>
    <LinkWrapper to={linkPath}>
      <PrimaryButton buttonColor={ButtonColor.Peach} to={linkPath}>
        {buttonText}
      </PrimaryButton>
    </LinkWrapper>
  </Wrapper>
);
